// Helper functions for task events table & timeline
import { TASK_EVENT_LABELS } from '../constants/taskEventLabels';

export function humanizeEvent(event) {
  const payload = event.payload || {};
  const mapper = TASK_EVENT_LABELS[event.eventType];
  return mapper ? mapper(payload) : event.eventType;
}

export function deriveCallerContext(events) {
  for (const event of events) {
    try {
      const attrs = JSON.parse(event.payload?.task_attributes || '{}');
      if (attrs.from && attrs.called) {
        return {
          caller: attrs.from,
            called: attrs.called,
            conversationTitle: attrs?.conversations?.conversation_attribute_3 || null
        };
      }
    } catch { /* ignore */ }
  }
  return null;
}

export function formatAge(seconds) {
  if (!seconds && seconds !== 0) return '-';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs < 10 ? '0' : ''}${secs}s`;
}

export function extractPreviousTaskData(events) {
  for (const event of events) {
    try {
      const attrs = JSON.parse(event.payload?.task_attributes || '{}');
      if (attrs.previousTaskSid || attrs.previosCallSid || attrs.name) {
        return {
          previousTaskSid: attrs.previousTaskSid || null,
          previosCallSid: attrs.previosCallSid || null,
          name: attrs.name || null,
        };
      }
    } catch { /* ignore */ }
  }
  return null;
}
